import useTokenStore, {resetUserScopedState} from "@/store/token";

/**
 * Replace the current session's tokens with another user's and reload.
 *
 * The reload already discards all in-memory state; the explicit reset makes sure
 * nothing user-scoped that persists to localStorage carries over either.
 */
export const switchSession = ({access, refresh}: {access: string; refresh: string}) => {
  const tokenStore = useTokenStore.getState();

  resetUserScopedState();
  tokenStore.setAccessToken(access);
  tokenStore.setRefreshToken(refresh);
  window.location.href = "/";
};
